import { Component, ElementRef, EventEmitter, Input, Output, HostBinding } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

import { ScrollPanelComponent } from '../../../Common/Basic/components/ScrollPanel/scroll-panel.component';

import { ButtonTypesEnum } from '../../../Common/Forms/enums/button-types.enum';
import { messageSeverityEnum } from '../../../Common/Misc/enums/message-severity.enum';

import { ViQuestionApi } from '../../../api/visibilityIntelligence/models/vi-question.api.model';
import { ViDimensionCard, QuestionScore } from '../../models/vi-dimension-card.model';


@Component({
    selector: 'agpr-vi-dimension-card',
    templateUrl: './vi-dimension-card.component.html',
    styleUrls: ['./vi-dimension-card.component.scss'],
    standalone: false,
    animations: [
        trigger('cardState', [
            state('collapsed', style({
                height: '0'
            })),
            state('expanded', style({
                height: '*'
            })),
            transition('collapsed <=> expanded', animate('220ms ease-in'))
        ])
    ]
})
export class ViDimensionCardComponent {

    @Input() id: string = 'viDimensionCard';
    @Input() card: ViDimensionCard<ViQuestionApi & Partial<QuestionScore>> | null = null;
    @Input() selectedQuestion?: ViQuestionApi | null = null;
    @Input() showMetrics: boolean = false;
    @Input() allowDelete: boolean = true;
    @Input() interactive: boolean = true;
    @Input() inverseArrows: boolean = false;

    @Output() questionSelected = new EventEmitter<ViQuestionApi & Partial<QuestionScore>>();
    @Output() questionDeleted = new EventEmitter<ViQuestionApi & Partial<QuestionScore>>();

    @HostBinding('class.is-interactive')
    get isInteractive(): boolean {
        return this.interactive;
    }

    readonly buttonTypes = ButtonTypesEnum;
    readonly messageSeverity = messageSeverityEnum;

    constructor(private elementRef: ElementRef) {}

    toggle(): void {
        if (!this.card) {
            return;
        }
        this.card.isExpanded = !this.card.isExpanded;
    }

    isSelected(question: ViQuestionApi): boolean {
        const selected = this.selectedQuestion;

        if (!selected) {
            return false;
        }

        if (selected === question) {
            return true;
        }

        return selected.id !== undefined && selected.id !== null && selected.id === question.id;
    }


    /** Expands the card if needed, then scrolls the first invalid question's item into view */
    scrollFirstErrorIntoView(scrollPanel?: ScrollPanelComponent): void {
        if (!this.card) {
            return;
        }
        this.card.isExpanded = true;

        requestAnimationFrame(() => {
            const index = this.card?.questions?.findIndex(question => !question.question?.trim() || !question.expectedAnswerSignals?.length) ?? -1;
            if (index < 0) {
                return;
            }

            const element: HTMLElement | null = this.elementRef.nativeElement.querySelector(`#${CSS.escape(this.id + '_question_' + index)}`);
            if (element) {
                ScrollPanelComponent.scrollElementIntoView(element, scrollPanel);
            }
        });
    }
}
